import React from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { store } from '../../config/firebase';
import { Box, CircularProgress, Typography, Link as MuiLink } from '@mui/material';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import Scoreboard from '../ui/gameControls/scoreboard';
import ScoringDisplay from '../ui/playerDisplay/scoringDisplay';
import ViewScorecardPhoto from '../ui/gameControls/viewScorecardPhoto';

import { getGameById } from '../../features/game/gameSlice';

const Scoring = () => {
  const { gameId } = useParams();
  const dispatch = useDispatch();
  const game = useSelector((state) => state.game.game);
  const [fsGame, setFSGame] = React.useState({});
  const event = useSelector((state) => state.event.event);

  React.useEffect(() => {
    const docRef = doc(store, 'games', gameId);
    const unsubscribe = onSnapshot(
      docRef,
      (docSnap) => {
        if (docSnap.exists()) {
          const gameData = { id: docSnap.id, ...docSnap.data() };
          setFSGame(gameData);
        } else {
          console.log('No game found!');
          setFSGame(null);
        }
      },
      (error) => {
        console.error('Firestore listener error:', error);
        setFSGame(null);
      }
    );

    return () => unsubscribe();
  }, [gameId]);

  React.useEffect(() => {
    // Fetch game by redux.
    dispatch(getGameById(gameId));
  }, [dispatch, gameId]);

  React.useEffect(() => {
    setFSGame(game);
  }, [game]);

  return fsGame ? (
    <Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        alignItems={'center'}
        justifyContent={'center'}
        mb={2}>
        {event && (
          <MuiLink
            component={Link}
            to={`/events/${fsGame.event}`}
            color="primary"
            underline="hover">
            {event?.name ?? 'Event'}
          </MuiLink>
        )}

        <Typography variant="h5" mb={2}>
          {fsGame.name ?? 'Private Game'}
        </Typography>
      </Box>
      <ScoringDisplay game={fsGame} />

      {fsGame.sets?.length && <Scoreboard game={fsGame} />}

      <Box flexDirection={'column'} sx={{ display: 'flex', justifyContent: 'center', mt: 2 }}>
        <Typography variant="caption" textAlign={'center'}>
          Event ID: {fsGame.event}
        </Typography>
        <Typography variant="caption" textAlign={'center'}>
          Game ID: {fsGame.id}
        </Typography>
        {fsGame.scorecardPhoto && <ViewScorecardPhoto game={fsGame} />}
      </Box>
    </Box>
  ) : (
    <CircularProgress />
  );
};

export default Scoring;
